import { styled } from '@mui/material'
import { Avatar, AvatarProps } from '@carto/meridian-ds/components'
import Icon from 'assets/icons/connectors/carto-dw.svg?react'

const sizes = {
  large: 5,
  medium: 4,
  small: 3,
  xsmall: 2.25
}

const CartoAvatar = styled(Avatar)(({ theme }) => ({
  backgroundColor: `${theme.palette.brand.navyBlue} !important`
}))

const CartoIcon = styled(Icon, { shouldForwardProp: (prop) => prop !== 'size' })<{ size: AvatarProps['size'] }>(
  ({ size = 'small', theme }) => ({
    width: `${theme.spacing(sizes[size] / 1.75)} !important`,
    height: `${theme.spacing(sizes[size] / 1.75)} !important`,

    '& path': {
      fill: 'inherit !important'
    }
  })
)

function CartoUserAvatar({ size, ...otherProps }: AvatarProps) {
  return (
    <CartoAvatar size={size} {...otherProps}>
      <CartoIcon size={size} />
    </CartoAvatar>
  )
}

export default CartoUserAvatar
